import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';

import { BrowserRouter } from 'react-router-dom'; // ADDED
import { ClerkProvider } from '@clerk/clerk-react';

import { LogProvider } from './contexts/logContext';

import App from './App.jsx';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
//const publishableKey = import.meta.env.CLERK_JERNY_PUBLIC_KEY;

createRoot(document.getElementById('root')).render(
    // <StrictMode>
    <LogProvider>
        <BrowserRouter>
            <ClerkProvider publishableKey={publishableKey} signUpForceRedirectUrl="/welcome" signInForceRedirectUrl="/dashboard">
                <App />
            </ClerkProvider>
        </BrowserRouter>{' '}
    </LogProvider>,
    // </StrictMode>
);
